// controls/selectMultiple.js — version refactorisée avec OptionsEditor
import React from "react";
import CommonControls from "./inc/Common";
import OptionsEditor from "./inc/OptionsEditor";

export function createSelectMultipleField() {
  return {
    type: "array",
    title: "Liste à choix multiples",
    "x-ui": "selectMultiple",
    "x-multiple": true,
    items: {
      type: "string",
      enum: [""],
    },
    uniqueItems: true,
    "x-options": [{ text: "> Sélectionner", value: "" }],
  };
}

export function EditSelectMultipleField({ field, onChange }) {
  const handleOptionsChange = (options) => {
    const updatedField = {
      ...field,
      "x-options": options,
      items: {
        ...field.items,
        enum: options.map((o) => o.value),
      },
    };
    onChange(updatedField);
  };

  return (
    <>
      <CommonControls field={field} onChange={onChange} />
      <OptionsEditor
        initialOptions={field["x-options"]}
        onChange={handleOptionsChange}
        label="Options (choix multiples autorisés)"
      />
    </>
  );
}

export const editSelectMultipleField = (props) => (
  <EditSelectMultipleField {...props} />
);

/* =========================================================
   🧩 FRONT — rendu du champ multi-sélection
   ========================================================= */
export const RenderSelectMultipleField = ({
  field,
  value,
  onChange,
  className,
  errorMessage    // <--- AJOUT
}) => {

  const options = field["x-options"] || [];
  const required = field.required || false;
  const multiple = field["x-multiple"] ?? true;
  const selectedValues = Array.isArray(value) ? value : [];

  const handleChange = (e) => {
    const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
    onChange?.(selected);
  };

  return (
    <div
      className={`
        fb-field fb-select-multiple
        ${field["x-bloc-class"] || "mb-3"}
        ${className || ""}
      `}
    >

      {/* Label */}
      {field.title && (
        <label className={`form-label ${errorMessage ? "text-danger" : ""}`}>
          {field.title} {required && <span className="text-danger">*</span>}
        </label>
      )}

      {/* Select multiple */}
      <select
        multiple={multiple}
        className={`
          form-select
          ${field["x-control-class"] || ""}
          ${errorMessage ? "is-invalid" : ""}
        `}
        value={selectedValues}
        onChange={handleChange}
      >
        {options.map((opt, i) => (
          <option key={i} value={opt.value}>
            {opt.text}
          </option>
        ))}
      </select>

      {/* Description */}
      {field.description && (
        <div className="form-text text-muted mt-1">{field.description}</div>
      )}

      {/* Message d’erreur */}
      {errorMessage && (
        <div className="invalid-feedback d-block mt-1">
          {errorMessage}
        </div>
      )}

    </div>
  );
};
